import { CommonHelperFunctions, IKuikaTypeResolution, ITypeModel } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export interface WidgetComponentInfo {
  widgetId: string;
  title: string;
  webComponentTag: string;
  componentName: string;
  props: {
    name: string;
    properties: Array<{
      name: string;
      type: number;
      isRequired: boolean;
      unionValues: string[] | null;
      elementType: any | null;
      functionParameters: any[];
      functionReturnType: string | null;
      typeReference: string | null;
      recordKeyType: any | null;
      recordValueType: any | null;
      resolvedProperties: any | null;
      resolvedElementProperties: any | null;
      defaultValue: any | null;
    }>;
  };
  resolvedProps?: IKuikaTypeResolution[];
  domainTypes?: ITypeModel[];
}

export interface WidgetProjectInfo {
  id: string;
  projectId: string;
  name: string;
  version: string;
  bundleSizeBytes: number;
  bundleHash: string;
  framework: string;
  createdAt: string;
  components: WidgetComponentInfo[];
}

export interface WidgetUsageInfo {
  projectName: string;
  projectId: string;
  screenName: string;
  screenId: string;
  componentId: string;
}

export interface WidgetDeleteResult {
  success: boolean;
  message: string;
  usageCheck?: {
    isInUse: boolean;
    totalUsageCount: number;
    usages: WidgetUsageInfo[];
  };
}

export class WidgetsService {
  public static async GetWidgetProjects(): Promise<AxiosResponse<WidgetProjectInfo[]>> {
    try {
      return await Axios.get<null, AxiosResponse<WidgetProjectInfo[]>>(`${backendUrl}/widgets`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async DeleteWidgetProject(widgetPackId: string): Promise<AxiosResponse<WidgetDeleteResult>> {
    try {
      return await Axios.delete<null, AxiosResponse<WidgetDeleteResult>>(
        `${backendUrl}/widgets/${encodeURIComponent(widgetPackId)}`
      );
    } catch (error: any) {
      // Return the error response if it contains usage data (409 Conflict)
      if (error.response?.data) {
        return error.response;
      }
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
